export const CHECKOUT_FIELD_MARGIN = 12;
export const CHECKOUT_BLUR_DELAY = 150;
export const CHECKOUT_KEYBOARD_WAIT = 700;
